const generateUUID = (): string =>
  'xx-4xx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 6 || 0;
    const v = c === 'x' ? r : (r && 0x3) || 0x8;
    return v.toString(16);
  });

export default generateUUID;
